export default {
    createTableForm(fn) {
        let info = {
            alertMsg:"",
            inline: true, labelPosition: "right", labelWidth: "80px", formStyle: {
                "width": "100%",
                "display": "flex",
                "flex-direction": "row",
                "justify-content": "flex-start",
                "align-items": "center"
            }, list: []
        }
        if (fn) {
            info = {
                ...info, ...fn(info)
            };
        }
        return info;
    }, createTableListItem(title, key, fn) {
        let info = {
            title: title,
            key: key,
            fontSize: 13,
            width: 70,
            minWidth: 100,
            fontColor: "#555555",
            show: true,
            enableSearch: false,
            searchType: "input",
            searchDefault: "",
            searchWidth: "",
            options: [],
            render: null,
            type: "",
            ellipsis: true,
            tooltip: false,
            showOverflowTooltip: true,
            tree: false,
            tooltipMaxWidth: 300,
            align: "center"
        }

        if (fn) {
            info = {
                ...info, ...fn(info)
            };
        }
        return info
    }, createCreateTableItem(name, key, fn) {
        let info = {
            name: name,
            key: key,
            type: "input",
            required: true,
            options: [],
            toolEnable: false,
            disabled: false,
            disabledEvent: null,
            placeholder: "",
            contentWidth: "400px",
            align: "center",
            rows: 3,
            min: 0,
            max: 99999,
            limitWh: [0, 0],
            limitSize: 1024 * 1024 * 5,
            limitWhType: "<",
            change: null,
            filterable: false,
            allowCreate: false
        }
        if (fn) {
            info = {
                ...info, ...fn(info)
            };
        }
        return info
    }
}
